import { Box, Tag } from '@factorialco/deprecated-design-system'
import { TrainingsSessionAttendanceStatusEnum } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'

import { AttendanceButton } from 'modules/trainings/components/Revamp/EmployeeClassesSidepanel/SessionsDatatable/BulkUpdateAttendanceAction/AttendanceButton'
import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

type Props = {
  status: TrainingsSessionAttendanceStatusEnum
  idsAttendance: number[]
}

const TrainingMembershipAttendanceDropdown = ({ status, idsAttendance }: Props) => {
  const { getSessionAttendanceColor, getSessionAttendanceTranslation } = useTrainingsDatatable()

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Box width="fit-content">
          <Tag rightItem="dropdown" inline showActionIcon type={getSessionAttendanceColor(status)}>
            {getSessionAttendanceTranslation(status)}
          </Tag>
        </Box>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end">
        <Box gap="s12" padding="s12">
          <AttendanceButton status={'pending'} idsAttendance={idsAttendance} />
          <AttendanceButton status={'inprogress'} idsAttendance={idsAttendance} />
          <AttendanceButton status={'completed'} idsAttendance={idsAttendance} />
          <AttendanceButton status={'missing'} idsAttendance={idsAttendance} />
        </Box>
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default TrainingMembershipAttendanceDropdown
